import { h, Component } from "preact";
import { Link } from "preact-router/match";
import { getApiPath } from "../../path";

import InnerPage from "../../components/inner-page";
import ContentList from "../../components/content-list";
import LinkList from "../../components/link-list";

import ParagraphSeperator from "../../components/paragraph-seperator";

import style from "./style";

import { contentListItems, headings } from "./mappings";
import MainImage from "../../components/main-image";
import BookDetailHeader from "../../components/book-detail-header";
import DetailSection from "../../components/detail-section";
import IsLoading from "../../components/is-loading";
import FourOFour from "../../components/four-o-four";

class BookDetail extends Component {
  state = {
    details: {
      id: 0,
      id_auteur: 0,
      trefwoorden: [{ id: 0, trefwoord: "" }],
      id_genre: 0,
      genre: "",
      id_annoteur: 0,
      annoteur: "",
      titel: "",
      jaar: 0,
      samenvatting: "",
      overBoek: "",
      afbeelding: "",
      citaten: [
        {
          id: 0,
          citaat: "",
          trefwoorden: [
            {
              id: 0,
              trefwoord: ""
            }
          ]
        }
      ],
      commentaar: [
        {
          id: 0,
          commentaar: ""
        }
      ],
      auteurDetails: {
        id: 0,
        voornaam: "",
        tussenvoegsel: "",
        achternaam: "",
        biografie: "",
        overAuteur: "",
        afbeelding: "",
        literatuur: [
          {
            id: 0,
            titel: "",
            jaar: 0
          }
        ]
      }
    },
    dbLoaded: false,
    hasResult: true,
    language: "nl"
  };

  componentDidMount() {
    const fetchPath = getApiPath(this.props.lang, "roman/detail", [
      this.props.id
    ]);
    fetch(fetchPath)
      .then(res => res.json())
      .then(result => {
        this.handleDetailsLoaded(result);
      })
      .catch(error => {
        console.error(
          "There was a problem connecting to the db from BookDetail",
          error
        );
        this.setState(previousState => ({
          ...previousState,
          details: [],
          dbLoaded: true,
          hasResult: false
        }));
      });
  }

  handleDetailsLoaded = ({ data, status }) => {
    let hasResult = false;
    let details = data;
    if (status === 200) {
      details = data;
      hasResult = true;
    }
    this.setState(previousState => ({
      ...previousState,
      dbLoaded: true,
      hasResult,
      details
    }));
  };

  render() {
    const { hasResult, dbLoaded } = this.state;
    let authorName = "";
    if (dbLoaded && hasResult) {
      const {
        voornaam,
        tussenvoegsel,
        achternaam
      } = this.state.details.auteurDetails;
      authorName = [voornaam, tussenvoegsel, achternaam].join(" ");
    }

    return (
      <InnerPage>
        {!dbLoaded && <IsLoading />}
        {dbLoaded && !hasResult && <FourOFour />}
        {dbLoaded &&
          hasResult && (
            <div class={style["book-detail"]}>
              <BookDetailHeader
                author={authorName}
                title={this.state.details.titel}
              />
              <MainImage src={this.state.details.afbeelding} />
              <ContentList items={contentListItems} />
              <DetailSection
                id="auteur"
                title={headings.auteur[this.state.language]}
              >
                <Link
                  href={`/${this.props.lang}/roman/author/${this.state.details.id_auteur}`}
                >
                  {authorName}
                </Link>
              </DetailSection>
              <DetailSection id="titel" title="titel">
                {this.state.details.titel} {this.state.details.jaar != 0 && "("+this.state.details.jaar+")"}
              </DetailSection>
              <DetailSection
                id="trefwoorden"
                title={headings.trefwoorden[this.state.language]}
              >
                <LinkList>
                  {this.state.details.trefwoorden.map(trefwoord => (
                    <Link
                      href={`/${this.props.lang}/quotes/keyword/${trefwoord.id}`}
                    >
                      {trefwoord.trefwoord}
                    </Link>
                  ))}
                </LinkList>
              </DetailSection>
              <DetailSection
                id="genre"
                title={headings.genre[this.state.language]}
              >
                <Link
                  href={`/${this.props.lang}/book/bygenre/${this.state.details.id_genre}`}
                >
                  {this.state.details.genre}
                </Link>
              </DetailSection>
              <DetailSection
                id="samenvatting"
                title={headings.samenvatting[this.state.language]}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.details.samenvatting
                  }}
                ></div>
              </DetailSection>
              <DetailSection
                id="commentaar"
                title={headings.commentaar[this.state.language]}
              >
                {this.state.details.commentaar.map((commentaar, idx, array) => [
                  <div
                    class={style["book__quote"]}
                    key={idx}
                    dangerouslySetInnerHTML={{ __html: commentaar.commentaar }}
                  ></div>,
                  idx !== array.length - 1 && <ParagraphSeperator />
                ])}
              </DetailSection>
              <DetailSection
                id="citaten"
                title={headings.citaten[this.state.language]}
              >
                {this.state.details.citaten.map((citaat, idx, array) => [
                  <ul class={style["quote__keywordlist"]}>
                    {citaat.trefwoorden.map((trefwoord, index) => (
                      <li key={index}>
                        <Link
                          href={`/${this.props.lang}/quotes/keyword/${trefwoord.id}`}
                        >
                          {trefwoord.trefwoord}
                        </Link>
                      </li>
                    ))}
                  </ul>,
                  <div
                    class={style["book__quote"]}
                    key={idx}
                    dangerouslySetInnerHTML={{ __html: citaat.citaat }}
                  ></div>,
                  idx !== array.length - 1 && <ParagraphSeperator />
                ])}
              </DetailSection>
              <DetailSection
                id="biografie"
                title={headings.biografie[this.state.language]}
              >
                {this.state.details.auteurDetails.biografie && [
                  <h4>{headings.bio[this.state.language]}</h4>,
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.details.auteurDetails.biografie
                    }}
                  ></div>,
                  <h4>{headings.biblio[this.state.language]}</h4>,
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.details.auteurDetails.bibliografie
                    }}
                  ></div>
                ]}
              </DetailSection>
              <DetailSection
                id="overAuteur"
                title={headings.overAuteur[this.state.language]}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.details.auteurDetails.overAuteur
                  }}
                ></div>
              </DetailSection>
              <DetailSection
                id="overBoek"
                title={headings.overBoek[this.state.language]}
              >
                {this.state.details.overBoek && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.details.overBoek
                    }}
                  ></div>
                )}
              </DetailSection>
            </div>
          )}
      </InnerPage>
    );
  }
}

export default BookDetail;
